import { add } from '../../prices/services/PricesService';
import { fetchRecords } from '../../products/services/ProductsService';
import { PriceStatus, PricingModel, RecurringOption, BillingPeriod } from '../../prices/types';

const priceStatuses = [PriceStatus.Active, PriceStatus.Inactive];
const pricingModels = [PricingModel.FlatRate, PricingModel.PackageBased, PricingModel.VolumeBased, PricingModel.UsageBased];
const recurringOptions = [RecurringOption.Yes, RecurringOption.No];
const billingPeriods = [BillingPeriod.Monthly, BillingPeriod.Annually, BillingPeriod.Weekly, BillingPeriod.Daily];

const descriptions = [
  'Basic Plan',
  'Premium Plan', 
  'Enterprise Plan',
  'Starter Package',
  'Professional Package',
  'Ultimate Package',
  'Standard Subscription',
  'Advanced Subscription'
];

const generatePriceData = (productId: string) => {
  const amount = Math.floor(Math.random() * 10000) + 500; // $5 to $100
  const description = descriptions[Math.floor(Math.random() * descriptions.length)];
  
  return {
    productId,
    priceStatus: priceStatuses[Math.floor(Math.random() * priceStatuses.length)],
    pricingModel: pricingModels[Math.floor(Math.random() * pricingModels.length)],
    recurringOption: recurringOptions[Math.floor(Math.random() * recurringOptions.length)],
    amount,
    description,
    billingPeriod: billingPeriods[Math.floor(Math.random() * billingPeriods.length)]
  };
};

export const generatePricesTestData = async (count: number, productId?: string) => {
  let targetProductId = productId;
  
  if (!targetProductId) {
    // Get available products if no productId provided
    const productsResponse = await fetchRecords({});
    const products = productsResponse?.items || [];
    
    if (products.length === 0) {
      throw new Error('No products available. Please create products first.');
    }
    
    targetProductId = products[Math.floor(Math.random() * products.length)].id;
  }
  
  const promises = [];
  
  for (let i = 1; i <= count; i++) {
    const priceData = generatePriceData(targetProductId);
    promises.push(add(priceData));
  }
  
  try {
    const results = await Promise.all(promises);
    console.log(`Generated ${count} test prices`);
    return results.filter(Boolean);
  } catch (error) {
    console.error('Error generating price test data:', error);
    return [];
  }
};